import { render } from "./WysiwygLinkDialog.vue?vue&type=template&id=73121c69&scoped=true"
import script from "./WysiwygLinkDialog.vue?vue&type=script&lang=ts"
export * from "./WysiwygLinkDialog.vue?vue&type=script&lang=ts"

import "./WysiwygLinkDialog.vue?vue&type=style&index=0&id=73121c69&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73121c69"

export default script